import Swiper from 'https://unpkg.com/swiper@8/swiper-bundle.esm.browser.min.js';

class TabsDestaque
{
    static settingsSwiper(parentID)
    {
        const settings = 
        {
            slidesPerView: 6,
            spaceBetween: 0,
            loop: false,
            navigation: {
                nextEl: `#${parentID} .swiper-button-next`,
                prevEl: `#${parentID} .swiper-button-prev`,
            },
            // pagination: {
            //     el: `#${parentID} .swiper-pagination`,
            //     clickable: true,
            // },
            breakpoints:
            {
                0: {
                    slidesPerView: "auto",
                    spaceBetween: 10,
                },
                568: {
                    slidesPerView: 4,
                    spaceBetween: 16,
                },
                1024: {
                    slidesPerView: 6,
                    spaceBetween: 24,
                }
            }
        };

        return settings;
    }

    static SwiperRender(tabComponenteContent)
    {
        tabComponenteContent.find('> div').each(function()
        {
            const swiperParent = $(this);
            const swiperParentID = swiperParent.attr('id');

            if(swiperParent.find('.swiper-container').length > 0)
            {
                const SwiperDestaques = new Swiper('#'+swiperParentID+' .swiper-container', TabsDestaque.settingsSwiper(swiperParentID));

                $(window).on("resize", function()
                {
                    SwiperDestaques.update();
                });
            }
        });
    }

    static getComponentElement(component)
    {
        const tabComponenteList = component.find('.selectCat ul');
        const buttonSelected = component.find('button.selectedCatDestaques');
        const buttonSelectedLabel = buttonSelected.find('span');
        const tabComponenteNavLi = component.find('.tabDestaqueNav li');
        const tabComponenteContent = component.find('.tabDestaqueContainer');
        
        tabComponenteNavLi.each(function()
        {
            let parent = $(this);
            let button = parent.find('button');
            let idContainer = button.data('tab');
            
            button.click(function()
            {
                tabComponenteNavLi.removeClass('activated');
                parent.addClass('activated');

                tabComponenteContent.find('> div').removeClass('activated');
                tabComponenteContent.find('div#'+idContainer).addClass('activated');
                tabComponenteContent.find('div#'+idContainer).focus();

                buttonSelectedLabel.text($(this).attr('name'));

                tabComponenteList.removeClass('Opened');
            });
        });

        TabsDestaque.SwiperRender(tabComponenteContent);

        buttonSelected.click(function()
        {
            tabComponenteList.toggleClass('Opened');
        })
        
        $(document).click(function (event) {
			if (!buttonSelected.is(event.target) && !tabComponenteList.is(event.target) && tabComponenteList.has(event.target).length === 0) {
				tabComponenteList.removeClass('Opened');
			}
		});
    }

    getDestaques()
    {
        if($('.tabComponente').length > 0)
        {
            $('.tabComponente').each(function()
            {
                TabsDestaque.getComponentElement($(this));
            });
        }
    }

    init()
	{
        const self = this;

        self.getDestaques();
	}
}

export default TabsDestaque;